import {Component} from '@angular/core';
import {AppService} from '../app.service';
import {CertificateService} from '../certificate.service';
import {Certificate} from '../models/certificate';
import {ActivatedRoute, Router} from '@angular/router';
import {CertificateStatus} from '../models/certificate-status.enum';
import {StateService} from '../state.service';
import {User} from '../models/User';

@Component({
  selector: 'app-page-2',
  templateUrl: './page-2.component.html',
  styleUrls: ['./page-2.component.scss', '../../vendor/libs/ngx-sweetalert2/ngx-sweetalert2.scss']
})
export class Page2Component {

  // public successDialog: any;

  constructor(private appService: AppService, private certificateService: CertificateService, private router: Router, private stateService: StateService, private route: ActivatedRoute) {
    this.appService.pageTitle = 'Otentica - Certificates';
  }

  public swalApprove = {
    title: 'Approve certificate',
    text: 'Are you sure you want to approve this certificate?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, approve it!',
    showCloseButton: true,
    customClass: {confirmButton: 'btn btn-lg btn-warning', cancelButton: 'btn btn-lg btn-default'}
  };

  public getCertificates(): Certificate[] {
    return this.certificateService.getCertificates();
  }

  public newCertificate(): void {
    this.router.navigate(['create-certificate']);
  }

  public certificateThumbnail(certificate: Certificate): {[key:string]: string} {
    if(!certificate.thumbnail) {
      return {};
    }
    return {
      'background': `url(/assets/${certificate.thumbnail})`
    };
  }

  public canApprove(): boolean {
    return this.stateService.isInstitution();
  }

  public canAddCertificate(): boolean {
    return this.stateService.isProfessional();
  }

  public isEligibleForApproval(certificate: Certificate): boolean {
    return certificate.status === CertificateStatus.PENDING_APPROVAL;
  }

  public approve(certificate: Certificate): void {
    certificate.status = CertificateStatus.APPROVED;
  }

  public viewCertificate(certificate: Certificate): void {
    this.router.navigate(['/view-certificate', certificate.identifier])
  }

  public currentUser(): User {
    return this.stateService.getCurrentUser();
  }

  public resolveUserFullname(username: string): string {
    return this.stateService.getUserByUsername(username).fullname;
  }

  public canViewCertificate(): (certificate: Certificate) => boolean {
    let stateService: StateService = this.stateService;
    let route: ActivatedRoute = this.route;
    return (certificate: Certificate) => {
      let user: User = stateService.getCurrentUser();
      let userId: string = route.snapshot.paramMap.get('userId');
      if(userId) {
        let owner: User = stateService.getUserByUsername(certificate.owner);
        return certificate.canView(user, stateService) && owner.id === userId;
      }
      return certificate.canView(user, stateService);
    }
  }
}
